import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { createRequestAction } from '~/Helpers/Action.helpers';
import { createQueriedURL, routeReplacer } from '~/Helpers/String.helper';
import { ILocation } from '~/Models/DTO/Location.models';

export const requestProviderLocationsList = (providerUUID: string, query?: any) =>
  createRequestAction({
    url: createQueriedURL(
      routeReplacer(PROVIDER_SERVICE_URLS.LOCATION_LIST, { providerUUID }),
      query,
    ),
    name: REQUEST_ACTIONS.LOCATION_LIST,
    method: 'GET',
  });

export const requestUpdateLocation = (location: ILocation, setRawDate?: Function) =>
  createRequestAction<ILocation>({
    url: routeReplacer(PROVIDER_SERVICE_URLS.LOCATION, { locationId: location.id }),
    name: REQUEST_ACTIONS.LOCATION_UPDATE,
    method: 'PUT',
    data: location,
    setRawDate,
  });

export const requestCreateLocation = (domain: string, location: ILocation, setRawDate?: Function) =>
  createRequestAction<ILocation>({
    url: routeReplacer(PROVIDER_SERVICE_URLS.LOCATION_CREATE, { domain }),
    name: REQUEST_ACTIONS.LOCATION_CREATE,
    method: 'POST',
    data: location,
    setRawDate,
  });
